import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import Auth from '../../api/auth';
import useApiQuery from '../../hooks/useApiQuery';
import TokenExpired from '../Error/TokenExpired';

import SetPassword from './SetPassword';

import type { APIHookArg } from '@/types';

interface UserVerification {
  verificationTokenExpired?: boolean;
  organizationName?: string;
}

const UserActivation = (): React.JSX.Element | null => {
  const navigate = useNavigate();
  const { token: verificationToken } = useParams<{ token: string }>();
  const [userVerification, setUserVerification] = useState<UserVerification | undefined>(undefined);

  const { makeApiCall: validateVerificationTokenCall } = useApiQuery(
    Auth.validateVerificationToken as unknown as APIHookArg,
    {
      errorMessage: 'incorrectToken',
    }
  );

  const { makeApiCall: activateUserCall } = useApiQuery(
    Auth.activateUser as unknown as APIHookArg,
    {
      successMessage: 'userActivated',
      errorMessage: 'userActivationErr',
    }
  );

  useEffect(() => {
    const validateToken = async (): Promise<void> => {
      try {
        const data = await validateVerificationTokenCall(verificationToken);
        if (data) setUserVerification(data);
      } catch (error) {
        console.error('Error validating token:', error);
      }
    };

    validateToken();
  }, [validateVerificationTokenCall, verificationToken]);

  const handleSubmit = async (newPassword: string): Promise<void> => {
    const data = await activateUserCall({
      verificationToken,
      newPassword,
      gtacAccepted: true,
    });
    if (data) navigate('/');
  };

  if (userVerification?.verificationTokenExpired) {
    return <TokenExpired />;
  }

  return userVerification?.organizationName ? (
    <SetPassword
      onSubmit={handleSubmit}
      organizationName={userVerification.organizationName}
    />
  ) : null;
};

export default UserActivation;
